import React, { useCallback, useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import { api } from './api'
import LandingPage from './LandingPage'
import { LoginPage, SignupPage, VerifyEmailPage } from './AuthPages'
import PricingPage from './PricingPage'
import DashboardPage from './DashboardPage'
import LegalPage from './LegalPage'
import { Spinner } from './components'

function ScrollTop() { const location = useLocation(); useEffect(() => window.scrollTo(0, 0), [location.pathname]); return null }

export default function App() {
  const [session, setSession] = useState(undefined)
  const refreshSession = useCallback(async () => {
    try { setSession(await api('/api/auth/me')) }
    catch (err) { if (err.status === 401) setSession(null); else throw err }
  }, [])
  useEffect(() => { refreshSession().catch(() => setSession(null)) }, [refreshSession])
  if (session === undefined) return <div className="full-loader"><Spinner/></div>
  return <><ScrollTop/><Routes>
    <Route path="/" element={<LandingPage/>}/>
    <Route path="/signup" element={session ? <Navigate to={`/pricing${window.location.search}`} replace/> : <SignupPage onAuthenticated={refreshSession}/>}/>
    <Route path="/login" element={session ? <Navigate to="/app" replace/> : <LoginPage onAuthenticated={refreshSession}/>}/>
    <Route path="/verify-email" element={<VerifyEmailPage onAuthenticated={refreshSession}/>}/>
    <Route path="/pricing" element={<PricingPage session={session}/>}/>
    <Route path="/app" element={session ? <DashboardPage session={session} refreshSession={refreshSession}/> : <Navigate to="/login" replace/>}/>
    <Route path="/privacy" element={<LegalPage type="privacy"/>}/>
    <Route path="/terms" element={<LegalPage type="terms"/>}/>
    <Route path="*" element={<Navigate to="/" replace/>}/>
  </Routes></>
}
